(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/components/lotto-onboarding.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/components/lotto-onboarding.js');

'use strict';

const {
  useState,
  useContext,
  useEffect
} = React;
const {
  ProlongContext
} = svs.numbergames.prolong_game.context;
const {
  WidgetAreaFullscreen
} = svs.components.onboarding.widgetAreaFullscreen;
const {
  onboardingClosingAction
} = svs.numbergames.prolong_game.common.utils;
const LottoOnboarding = _ref => {
  let {
    widgetArea
  } = _ref;
  const [isOpen, setIsOpen] = useState(false);
  const {
    isNewRules,
    isShowRuleChangeInfo
  } = useContext(ProlongContext);
  const handleNavigationChange = () => {
    if (history.state && history.state.fullscreen) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
      history.replaceState({}, '', window.location.pathname);
    }
  };
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflowY = 'hidden';
      const timeoutElement = setTimeout(() => {
        const divNode = Object.assign(document.createElement('div'), {
          className: 'mutation-observer-trigger-node'
        });
        document.body.appendChild(divNode);
      }, 50);
      const timeoutListener = setTimeout(() => {
        onboardingClosingAction(setIsOpen);
      }, 100);
      return () => {
        clearTimeout(timeoutElement);
        clearTimeout(timeoutListener);
        const node = document.querySelector('.mutation-observer-trigger-node');
        if (node) {
          document.body.removeChild(node);
        }
      };
    }
    document.body.style.overflowY = 'unset';
  }, [isOpen]);
  if (!isShowRuleChangeInfo) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "prolong-onboarding-container u-border-radius-6 padding-2 bg-tur-100 margin-top-1 margin-bottom-2"
  }, isNewRules ? React.createElement("span", null, "Nu fler miljonvinster och fler vinstchanser p\xE5 Lotto! F\xF6r att g\xF6ra detta m\xF6jligt har radpriset h\xF6jts med 1\xA0kr.\xA0") : React.createElement("span", null, "Fler miljonvinster och fler vinstchanser fr\xE5n och med september. F\xF6r att g\xF6ra detta m\xF6jligt h\xF6js radpriset med 1\xA0kr.\xA0"), React.createElement("a", {
    "aria-label": "L\xE4s mer om \xE4ndringarna",
    onClick: () => setIsOpen(true)
  }, "L\xE4s mer om \xE4ndringarna")), isOpen && ReactDOM.createPortal(React.createElement("div", {
    className: "prolong-fullscreen-container"
  }, React.createElement(WidgetAreaFullscreen, {
    onCloseFullscreen: () => {
      history.replaceState({}, '', window.location.pathname);
      handleNavigationChange();
    },
    widgetAreaName: widgetArea,
    branding: "lotto"
  })), document.getElementById('main-content')));
};
setGlobal('svs.numbergames.prolong_game.components.LottoOnboarding', LottoOnboarding);

 })(window);